var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4157 16.7739C17.9396 16.9485 18.506 16.6654 18.6807 16.1415C18.8553 15.6176 18.5722 15.0512 18.0483 14.8765L17.4157 16.7739ZM13.3455 14.3627H12.3455C12.3455 14.7931 12.6209 15.1752 13.0292 15.3114L13.3455 14.3627ZM14.3455 8.24732C14.3455 7.69504 13.8978 7.24732 13.3455 7.24732C12.7932 7.24732 12.3455 7.69504 12.3455 8.24732H14.3455ZM18.0483 14.8765L13.6618 13.414L13.0292 15.3114L17.4157 16.7739L18.0483 14.8765ZM14.3455 14.3627V8.24732H12.3455V14.3627H14.3455ZM24.0428 12.9002C24.0428 18.8099 19.2532 23.6002 13.3455 23.6002V25.6002C20.3583 25.6002 26.0428 19.914 26.0428 12.9002H24.0428ZM13.3455 23.6002C7.43783 23.6002 2.64828 18.8099 2.64828 12.9002H0.648285C0.648285 19.914 6.33281 25.6002 13.3455 25.6002V23.6002ZM2.64828 12.9002C2.64828 6.99053 7.43783 2.2002 13.3455 2.2002V0.200195C6.33281 0.200195 0.648285 5.8864 0.648285 12.9002H2.64828ZM13.3455 2.2002C19.2532 2.2002 24.0428 6.99053 24.0428 12.9002H26.0428C26.0428 5.8864 20.3583 0.200195 13.3455 0.200195V2.2002Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.54c218ebfa1b2efdb8a8f96d3e7101fb.svg";
export { ForwardRef as ReactComponent };